var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 7.08203H9.95703C7.78003 7.08203 6.58203 8.28003 6.58203 10.457V19.207C6.58203 21.384 7.78003 22.582 9.95703 22.582H18.707C20.884 22.582 22.082 21.384 22.082 19.207V10.457C22.082 8.28003 20.884 7.08203 18.707 7.08203ZM20.582 19.207C20.582 20.539 20.039 21.082 18.707 21.082H9.95703C8.62503 21.082 8.08203 20.539 8.08203 19.207V10.457C8.08203 9.12503 8.62503 8.58203 9.95703 8.58203H18.707C20.039 8.58203 20.582 9.12503 20.582 10.457V19.207ZM4.08203 6.45203V15.212C4.08203 16.41 4.56512 16.705 4.72412 16.803C5.07812 17.019 5.18792 17.481 4.97192 17.834C4.82992 18.065 4.58405 18.192 4.33105 18.192C4.19805 18.192 4.06194 18.156 3.93994 18.082C3.03894 17.53 2.58203 16.565 2.58203 15.212V6.45203C2.58203 4.31003 3.81115 3.08203 5.95215 3.08203H14.7119C16.3969 3.08203 17.202 3.821 17.582 4.44C17.798 4.793 17.687 5.25501 17.334 5.47101C16.98 5.68801 16.52 5.57602 16.303 5.22302C16.206 5.06402 15.9099 4.58105 14.7119 4.58105H5.95215C4.62415 4.58205 4.08203 5.12403 4.08203 6.45203Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.5e5423ff33a252e8d7b178ecb303c844.svg";
export { ForwardRef as ReactComponent };